"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyTree = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const react_redux_1 = require("react-redux");
const add_node_modal_1 = require("./components/add-node-modal");
const delete_node_modal_1 = require("./components/delete-node-modal");
const strategy_tree_content_component_1 = require("./components/strategy-tree-content.component");
const tree_actions_menu_1 = require("./components/tree-actions-menu");
const use_attribute_filter_tree_nodes_hook_1 = require("./hooks/use-attribute-filter-tree-nodes.hook");
const use_highlight_created_node_hook_1 = require("./hooks/use-highlight-created-node.hook");
const use_manage_node_menu_hook_1 = require("./hooks/use-manage-node-menu.hook");
const use_strategy_tree_filtering_hook_1 = require("./hooks/use-strategy-tree-filtering.hook");
const use_tree_node_filtering_hook_1 = require("./hooks/use-tree-node-filtering.hook");
const strategy_tree_l1_category_dropdown_component_1 = require("./strategy-tree-l1-category-dropdown.component");
const strategy_tree_styles_1 = require("./strategy-tree.styles");
const use_get_enriched_categories_hook_1 = require("../../client/product-tree-nodes/hooks/use-get-enriched-categories.hook");
const section_title_styles_1 = require("../../components/section-title/section-title.styles");
const context_1 = require("../../context");
const localization_1 = require("../../../localization");
const store_1 = require("../../../store");
const StrategyTree = ({ treeData }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isInEnrichmentHierarchy } = (0, context_1.useCatalogActivityProgressContext)();
    const { isProductTreeEditingEnabled, anchorEl, selectedProductTreeNode, onOpenManageNodeMenu, onCloseManageNodeMenu, setProductTreeNode, onResetTreeNode, } = (0, use_manage_node_menu_hook_1.useManageNodeMenu)();
    const [isAddNodeModalOpen, setIsAddNodeModalOpen] = (0, react_1.useState)(false);
    const [isDeleteNodeModalOpen, setIsDeleteNodeModalOpen] = (0, react_1.useState)(false);
    const handleAddNodeModalClose = () => {
        setIsAddNodeModalOpen(false);
        onResetTreeNode();
    };
    const handleDeleteNodeModalClose = () => {
        setIsDeleteNodeModalOpen(false);
        onResetTreeNode();
    };
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const actionsEnabled = isProductTreeEditingEnabled;
    const isRootReEnriching = isInEnrichmentHierarchy(productTreeRootNodeId);
    const selectedStrategyNodePath = (0, store_1.useSelectedTreeNodePath)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedProductTreeId = (0, store_1.useProductTreeId)();
    const listExpanded = (0, store_1.useExpandedNodes)();
    const { allowedL1Ids, setExtendedFilter, clearExtendedFilter, clearExclusiveFilter, selectedCategories, } = (0, use_tree_node_filtering_hook_1.useTreeNodeFiltering)();
    const { allowedNodeIds, } = (0, use_strategy_tree_filtering_hook_1.useStrategyTreeFiltering)();
    const { attributeFilterL1Ids, attributeFilterNodePaths, isAttributeFilterActive, } = (0, use_attribute_filter_tree_nodes_hook_1.useAttributeFilterTreeNodes)();
    const visibleL1Ids = allowedL1Ids && attributeFilterL1Ids
        ? allowedL1Ids.filter((id) => attributeFilterL1Ids.includes(id))
        : attributeFilterL1Ids !== null && attributeFilterL1Ids !== void 0 ? attributeFilterL1Ids : allowedL1Ids;
    const { data: enrichedSelectedCategories, } = (0, use_get_enriched_categories_hook_1.useGetEnrichedCategories)(selectedCategories);
    // Enhanced setExtendedFilter that combines Redux state update with GraphQL filtering
    const handleCategorySelectionChangedEnhanced = (0, react_1.useCallback)((selection) => {
        setExtendedFilter(selection);
    }, [setExtendedFilter]);
    const handleToggle = (0, react_1.useCallback)((event, itemIds) => {
        event.stopPropagation();
        dispatch((0, store_1.enrichAISetExpandedNodes)(itemIds));
    }, [dispatch]);
    const handleNodeSelect = (0, react_1.useCallback)((_, nodePath) => {
        dispatch((0, store_1.enrichAISetSelectedTreeNodePath)(nodePath));
    }, [dispatch]);
    const handleClearSelectedNode = selectedStrategyNodePath
        ? () => {
            dispatch((0, store_1.enrichAISetSelectedTreeNodePath)(undefined));
            dispatch((0, store_1.enrichAIClearAttributesFilter)());
            clearExtendedFilter(); // Clear manual filter selections
            clearExclusiveFilter(); // Clear force-visible nodes
            dispatch((0, store_1.enrichAISetExpandedNodes)([]));
        }
        : undefined;
    const handleAddNodeUnderTheRootLevel = () => {
        const root = treeData === null || treeData === void 0 ? void 0 : treeData.productTreeNode;
        if (!root)
            return null;
        const { id, title, description } = root;
        setProductTreeNode({
            id,
            title,
            description,
            isRootNode: true,
            path: id,
        });
        setIsAddNodeModalOpen(true);
    };
    const handleAddNode = (0, react_1.useCallback)(() => {
        setIsAddNodeModalOpen(true);
        onCloseManageNodeMenu();
    }, [onCloseManageNodeMenu]);
    const handleDeleteNode = (0, react_1.useCallback)(() => {
        setIsDeleteNodeModalOpen(true);
        onCloseManageNodeMenu();
    }, [onCloseManageNodeMenu]);
    const handleAction = (0, react_1.useCallback)((element, node) => {
        onOpenManageNodeMenu(element, node);
    }, [onOpenManageNodeMenu]);
    return (react_1.default.createElement(use_highlight_created_node_hook_1.NodeHighlightProvider, null, react_1.default.createElement(strategy_tree_styles_1.StyledHeaderContainer, null, react_1.default.createElement(section_title_styles_1.StyledSectionTitle, null, react_1.default.createElement(ui_components_1.Typography, { accent: true }, t({ key: 'STRATEGY_PREVIEW_TITLE' }))), react_1.default.createElement(strategy_tree_styles_1.StyledButtonWrapper, null, react_1.default.createElement(strategy_tree_l1_category_dropdown_component_1.StrategyTreeL1CategoryDropdown, { selectedCatalogId: selectedCatalogId, onSelect: handleCategorySelectionChangedEnhanced, productTreeRootNodeId: productTreeRootNodeId, selectedProductTreeId: selectedProductTreeId, selectedCategories: enrichedSelectedCategories }), actionsEnabled && !isRootReEnriching && (react_1.default.createElement(strategy_tree_styles_1.StyledAddNodeButton, { size: "small", endIcon: react_1.default.createElement(ui_components_1.Icon, { variant: "addRounded" }), onClick: handleAddNodeUnderTheRootLevel })))), react_1.default.createElement(strategy_tree_styles_1.StyledButtonWrapper, null, react_1.default.createElement(ui_components_1.Button, { rounded: true, error: true, type: "button", size: "small", onClick: handleClearSelectedNode }, t({ key: 'CLEAR' }))), react_1.default.createElement(material_1.Divider, null), react_1.default.createElement(strategy_tree_styles_1.StyledTree, { expandedItems: listExpanded, selectedItems: selectedStrategyNodePath !== null && selectedStrategyNodePath !== void 0 ? selectedStrategyNodePath : null, onExpandedItemsChange: handleToggle, onSelectedItemsChange: handleNodeSelect, expansionTrigger: "iconContainer", itemChildrenIndentation: "1.25rem" }, react_1.default.createElement(strategy_tree_content_component_1.StrategyTreeContent, { treeData: treeData, productTreeRootNodeId: productTreeRootNodeId, selectedCategories: isAttributeFilterActive ? [] : enrichedSelectedCategories, allowedL1Ids: visibleL1Ids, allowedNodeIds: attributeFilterNodePaths !== null && attributeFilterNodePaths !== void 0 ? attributeFilterNodePaths : allowedNodeIds, hasAttributeFilter: isAttributeFilterActive, actionsEnabled: actionsEnabled, onAction: handleAction })), !!selectedProductTreeNode && (react_1.default.createElement(tree_actions_menu_1.TreeActionsMenu, { anchorEl: anchorEl, selectedProductTreeNode: selectedProductTreeNode, onClose: onCloseManageNodeMenu, handleAddNode: handleAddNode, handleDeleteNode: handleDeleteNode })), react_1.default.createElement(add_node_modal_1.AddNodeModal, { open: isAddNodeModalOpen, onClose: handleAddNodeModalClose, treeNodeParentToAddTo: selectedProductTreeNode }), react_1.default.createElement(delete_node_modal_1.DeleteNodeModal, { open: isDeleteNodeModalOpen, onClose: handleDeleteNodeModalClose, selectedProductTreeNode: selectedProductTreeNode })));
};
exports.StrategyTree = StrategyTree;
exports.default = exports.StrategyTree;
